// Keep each URL paired with its actual width, including the original upload.
export function imageCandidates(attributes = {}) {
  const candidates = [attributes, ...Object.values(attributes.formats || {})]
    .filter(image => image?.url && image.width > 0)
    .sort((a, b) => a.width - b.width);

  return candidates.filter((image, index) =>
    candidates.findIndex(candidate => candidate.width === image.width) === index
  );
}

export function imageSrcSet(attributes) {
  return imageCandidates(attributes).map(image => `${image.url} ${image.width}w`).join(', ');
}

export function originalImage(attributes = {}) {
  if (attributes.url && attributes.width && attributes.height) return attributes;
  const candidates = imageCandidates(attributes);
  return candidates[candidates.length - 1] || attributes;
}

export function isVideoMedia(attributes = {}) {
  return attributes.mime?.startsWith('video/') || /\.(mp4|webm|mov)(?:[?#]|$)/i.test(attributes.url || '');
}
